import React, { useState } from 'react'
import styles from './styles.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import translate from '../../../core/translate'
import Button from '../../../blocks.simple/button/button'
import { api } from '../../../core/api/ConnectionManager'
import { ISelectedInfo } from '../__info/displays__info.local.methods'

export const TagsOnGroup = ({ onClose, selectedInfo }: { onClose: () => void; selectedInfo: ISelectedInfo | null }) => {
    const [tagTemplateString, setTagTemplateString] = useState<string>('')

    const onSave = () => {
        if (selectedInfo) {
            api.send('setTagsByGroupId', { groupId: selectedInfo.id, tagTemplateString }).then(() => {
                onClose()
            })
        }
    }

    return (
        selectedInfo && (
            <div className={styles.modalContainer}>
                <div className={styles.modalInner}>
                    <div className={styles.caption}>{translate('tagsAutomaticallyAssign')}</div>
                    <div className={styles.description}>
                        {translate('groupsOnTagsDescription')}: <span>{selectedInfo.name}</span>
                    </div>
                    <EditText
                        label={translate('enterTagTemplate')}
                        placeholder={translate('enterTagPlaceholder')}
                        value={tagTemplateString}
                        onChange={setTagTemplateString}
                    />
                    <div className={styles.tip}>{translate('enterTagExample')}</div>
                    <div className={styles.buttons}>
                        <Button mod="withBorder" className={styles.button} onClick={onClose}>
                            {translate('cancel')}
                        </Button>
                        <Button
                            disabled={!tagTemplateString}
                            mod={'fill'}
                            className={styles.button}
                            onClick={() => onSave()}
                        >
                            {translate('assign')}
                        </Button>
                    </div>
                </div>
            </div>
        )
    )
}
